<template>
    <div class="how-to-play__title">
        <h1>{{ getTranslatedText("How to play") }}</h1>
    </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins"

export default {
    mixins: [languageMixins],
}
</script>

<style lang="scss">
@import "~ThemePath/scss/home/index.scss";
</style>
